import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  location.pathname === link.path
                    ? "text-primary-600"
                    : "text-foreground-700 hover:text-primary-500"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer rounded-md border border-primary-300 text-primary-600 hover:bg-primary-50 transition-colors duration-200"
            >
              联系我们
            </Link>
            <button
              type="button"
              className="px-5 py-2 text-sm font-medium whitespace-nowrap cursor-pointer rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200"
            >
              立即注册
            </button>
          </div>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-800"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? "关闭菜单" : "打开菜单"}
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap py-2 cursor-pointer ${
                  location.pathname === link.path
                    ? "text-primary-600"
                    : "text-foreground-700"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-2 border-t border-background-200">
              <Link
                to="/about"
                className="flex-1 text-center px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer rounded-md border border-primary-300 text-primary-600"
              >
                联系我们
              </Link>
              <button
                type="button"
                className="flex-1 px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer rounded-md bg-primary-500 text-background-50"
              >
                立即注册
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}